export const TEACHER_VIEW_STUDENT_QUIZ_RESULT =
  'TEACHER_VIEW_STUDENT_QUIZ_RESULT';
export const TEACHER_OR_STUDENT_TAKING_QUIZ = 'TEACHER_OR_STUDENT_TAKING_QUIZ';
